/* eslint-disable */
'use strict';

import Helpers from "../shared/helpers";
import Collection from "./collection";

const ProductGrid = {
    init: function() {
        const productGrid = document.querySelector('.product-grid');
        if (productGrid) {
            this.productGridPillsRemoveSingleAndAll();
        }
        const removeAllLink = document.querySelector('.js-product-grid__products-remove-all');
        if (removeAllLink) {
            if(window.innerWidth < 768) {
                this.appendRemoveAllLink();
            }
        }
        const filters = document.querySelector('.js-product-grid__filter');
        if (filters) {
            if(window.innerWidth < 768) {
                this.filtersOpenResponsive();
            }
            if(window.innerWidth > 767) {
                this.productFiltersSticky();
            }
        }
        this.quickModalPopup();
        //Helpers.quickModalActions();
    },

    productFiltersSticky: function() {
        const containerLeft = document.querySelector('.js-product-grid__filter');
		const container = document.querySelector('.product-grid__bottom');
        
		if (container && containerLeft) {            
            const header = document.getElementById('masthead');
 
            let headerHeight = 0;
            if(header) {
                headerHeight = header.offsetHeight;
            }
            
            containerLeft.style.top = headerHeight + 10 + 'px';
        }   
	},

    productGridPillsRemoveSingleAndAll: function() {
        const pillCloseIcons = document.querySelectorAll('.js-product-grid__products-pill-close');
        const removeAllButton = document.querySelector('.js-product-grid__products-remove-all');
        pillCloseIcons.forEach(function(pillCloseIcon) {
            pillCloseIcon.addEventListener('click', function() {
                const pill = pillCloseIcon.parentElement;
                pill.classList.add('is-removed');
            });
        });
        removeAllButton.addEventListener('click', function() {
            const pills = document.querySelectorAll('.product-grid__products-pill');
            pills.forEach(function(pill) {
              pill.classList.add('is-removed');
            });
            removeAllButton.classList.add('is-hidden');
        });
    },

    filtersOpenResponsive: function() {
        const filterButton = document.querySelector('.js-product-grid__upper-btn');
        const filterContainer = document.querySelector('.js-product-grid__filter');
        const filterInner = document.querySelector('.js-product-grid__filter-inner');
        const closeButton = document.querySelector('.js-product-grid__filter-close');
        const body = document.body;
      
        // Event listener for filter button click
        filterButton.addEventListener('click', function() {
            filterContainer.classList.add('is-active');
            body.style.overflow = 'hidden';
        });
      
        // Event listener for close button click
        closeButton.addEventListener('click', function() {
            filterContainer.classList.remove('is-active');
            body.style.overflow = '';
        });
      
        // Event listener for click outside filter inner
        filterContainer.addEventListener('click', function(event) {
          if (!filterInner.contains(event.target) && filterContainer.classList.contains('is-active')) {
            filterContainer.classList.remove('is-active');
            body.style.overflow = '';
          }
        });
    },

    appendRemoveAllLink: function() {
        const filterTitleElement = document.querySelector('.product-grid__filter-main-title');
        const newElement = document.createElement('a');
        newElement.classList.add('is-hidden', 'product-grid__products-remove-all--mobile', 'js-product-grid__products-remove-all');
        newElement.href = 'javascript:;';
        newElement.textContent = 'Remove Filters';
        filterTitleElement.parentNode.insertBefore(newElement, filterTitleElement.nextSibling);
    },

    quickModalPopup: function() {
        const triggerButtons = document.querySelectorAll('.js-quick-buy-modal-trigger');
        const body = document.querySelector('body');
        const html = document.querySelector('html');

        function openModal(modal) {
            if (!modal) return;
            modal.classList.add('is-active');
            body.classList.add('prevent-scroll');
            html.classList.add('prevent-scroll');
        }

        function closeModal(modal) {
            if (!modal) return;

            modal.classList.remove('is-active');
            body.classList.remove('prevent-scroll');
            html.classList.remove('prevent-scroll');
        }

        function openCartDrawer() {
            if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.show) {
                window.Rebuy.SmartCart.show();
            } else if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.show) {
                window.Rebuy.Cart.show();
            } else if (window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.open) {
                window.Rebuy.Cart.open();
            } else {
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                document.dispatchEvent(new CustomEvent('cart:open'));
            }
        }

        triggerButtons.forEach(function(button) {
            button.addEventListener('click', function(event) {
                event.preventDefault();

                const popupNum = button.dataset.popup;
                const modal = document.querySelector('.js-quick-buy-modal--' + popupNum);

                openModal(modal);
            });
        });

        document.querySelectorAll('.js-quick-buy-modal__close-icon').forEach(function(icon) {
            icon.addEventListener('click', function() {
                document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
                    closeModal(modal);
                });
            });
        });

        document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
            modal.addEventListener('click', function(event) {
                if (!modal.querySelector('.js-quick-buy-modal__inner').contains(event.target)) {
                    closeModal(modal);
                }
            });
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') {
                document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
                    closeModal(modal);
                });
            }
        });

        document.querySelectorAll('.quick-buy-modal__buy-input-indicator--minus').forEach(function(el) {
            el.addEventListener('click', function(e) {
                ProductGrid.quantityEvent(e, 0);
            });
        });

        document.querySelectorAll('.quick-buy-modal__buy-input-indicator--plus').forEach(function(el) {
            el.addEventListener('click', function(e) {
                ProductGrid.quantityEvent(e, 1);
            });
        });

        document.addEventListener('click', function(event) {
            const button = event.target.closest('.quick-buy-modal__buy-btn');

            if (!button || button.disabled || button.classList.contains('disabled')) return;

            event.preventDefault();

            const form = button.closest('form');

            if (!form) {
                console.log('Quick modal form not found');
                return;
            }

            const productIdInput = form.querySelector('[name="id"]');
            const quantityInput = form.querySelector('[name="quantity"]');
            const sellingPlanInput = form.querySelector('[name="selling_plan"]');

            const productId = productIdInput ? productIdInput.value : null;
            const quantity = parseInt(quantityInput ? quantityInput.value : 1, 10) || 1;
            const sellingPlan = sellingPlanInput ? sellingPlanInput.value : null;

            if (!productId) {
                console.log('Product ID not found');
                return;
            }

            const requestBody = {
                id: productId,
                quantity: quantity
            };

            if (sellingPlan) {
                requestBody.selling_plan = sellingPlan;
            }

            // Disable button and show loading state to prevent duplicate submissions
            button.disabled = true;
            const originalButtonText = button.textContent;
            button.textContent = 'Adding...';

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody)
            })
            .then(function(response) {
                if (!response.ok) {
                    return response.json().then(function(err) {
                        throw new Error(err.description || err.message || 'Failed to add to cart');
                    });
                }
                return response.json();
            })
            .then(function(data) {
                document.querySelectorAll('.js-quick-buy-modal').forEach(function(modal) {
                    closeModal(modal);
                });

                openCartDrawer();
            })
            .catch(function(error) {
                console.error('Quick modal add to cart error:', error);
                alert(error.message || 'Failed to add to cart. Please try again.');
            })
            .finally(function() {
                button.disabled = false;
                button.textContent = originalButtonText;
            });
        });
    },

    quantityEvent: function (e, flag) {
        const parentElement = e.target.closest('a');
        const quantityInput = document.querySelector(`.js-quantity-${parentElement.dataset.product}`);
        const variantID = document.querySelector('.js-product-id').value;
        const variantData = Helpers.getVariantData(variantID);
        
        const value = parseInt(quantityInput.value);
        let newValue = 0;

        if (flag) {
            newValue = value + 1;
        } else {
            newValue = value - 1;
        }

        if (newValue) {
            quantityInput.value = newValue;
            Helpers.updateBWP(variantData.sku, newValue);
        }
    }
    
};

export default ProductGrid;